<app-breadcrumb
	[title]="t('إدارة خطط الاشتراك v2', 'Invoice Subscriptions v2', 'ניהול מנויים v2')"
	[items]="[t('لوحة التحكم', 'Dashboard', 'לוח בקרה')]"
	[active_item]="t('الخطط', 'Plans', 'תוכניות')"
></app-breadcrumb>

<div class="container-fluid basic_table">
	<div class="card">
		<div class="card-header d-flex justify-content-between flex-wrap gap-2">
			<h5 class="mb-0">
				{{ t('إدارة الكتالوجات', 'Plans Catalog Management', 'ניהול קטלוג תוכניות') }}
			</h5>
			<div class="d-flex gap-2">
				<button class="btn btn-dark" (click)="openCreateModal(planModal)">
					<i class="fa fa-plus-circle mx-1"></i>
					{{ t('إضافة خطة', 'Add Plan', 'הוסף תוכנית') }}
				</button>
				<button class="btn btn-outline-success" type="button" (click)="goToCustomPayments()">
					<i class="fa fa-credit-card mx-1"></i>
					{{ t('المدفوعات المخصصة', 'Custom Payments', 'תשלומים מותאמים') }}
				</button>
				<button class="btn btn-outline-primary" (click)="goToMerchantSubscriptions()">
					<i class="fa fa-users mx-1"></i>
					{{ t('إدارة الاشتراكات', 'Subscriptions Management', 'ניהול מנויים') }}
				</button>
				<button class="btn btn-outline-warning" (click)="loadAllCatalogs()">
					<i class="fa fa-refresh mx-1"></i>
					{{ t('تحديث', 'Refresh', 'רענון') }}
				</button>
			</div>
		</div>

		<div class="card-body">
			<ul class="nav nav-pills mb-3 plan-tabs">
				<li class="nav-item">
					<button
						type="button"
						class="nav-link"
						[class.active]="activeTab === 'main'"
						(click)="setActiveTab('main')"
					>
						{{ t('الخطط الرئيسية', 'Main Plans', 'תוכניות ראשיות') }}
					</button>
				</li>
				<li class="nav-item">
					<button
						type="button"
						class="nav-link"
						[class.active]="activeTab === 'doc'"
						(click)="setActiveTab('doc')"
					>
						{{ t('تمديد المستندات', 'Doc Extensions', 'הרחבות מסמכים') }}
					</button>
				</li>
				<li class="nav-item">
					<button
						type="button"
						class="nav-link"
						[class.active]="activeTab === 'company'"
						(click)="setActiveTab('company')"
					>
						{{ t('تمديد الشركات', 'Company Extensions', 'הרחבות חברות') }}
					</button>
				</li>
				<li class="nav-item">
					<button
						type="button"
						class="nav-link"
						[class.active]="activeTab === 'token'"
						(click)="setActiveTab('token')"
					>
						<i class="fa fa-magic mx-1"></i>
						{{ t('تمديد التوكنات', 'Token Extensions', 'הרחבות טוקנים') }}
					</button>
				</li>
			</ul>

			<div class="row mb-3">
				<div class="col-md-6">
					<label class="form-label">
						{{ t('بحث', 'Search', 'חיפוש') }}
					</label>
					<input
						type="text"
						class="form-control"
						[(ngModel)]="term"
						[ngModelOptions]="{standalone: true}"
						placeholder="{{ t('اكتب اسم أو وصف الخطة', 'Type plan name or description', 'הקלד שם או תיאור תוכנית') }}"
					/>
				</div>
			</div>

			<div class="table-responsive">
				<table class="table table-hover table-bordered text-center align-middle">
					<thead class="table-light">
						<tr>
							<th>#</th>
							<th>{{ t('الاسم', 'Name', 'שם') }}</th>
							<th>{{ t('الوصف', 'Description', 'תיאור') }}</th>
							<th>{{ t('السعر', 'Price', 'מחיר') }}</th>
							<th *ngIf="activeTab === 'main'">
								{{ t('حد المستندات', 'Documents Limit', 'מגבלת מסמכים') }}
							</th>
							<th *ngIf="activeTab === 'main'">
								{{ t('حد الشركات', 'Companies Limit', 'מגבלת חברות') }}
							</th>
							<th *ngIf="activeTab === 'main'">
								{{ t('المدة بالأيام', 'Duration Days', 'משך בימים') }}
							</th>
							<th *ngIf="activeTab === 'main'">
								{{ t('حد توكنات التحليل', 'Analysis tokens limit', 'מגבלת טוקני ניתוח') }}
							</th>
							<th *ngIf="activeTab === 'doc'">
								{{ t('مستندات إضافية', 'Extra Documents', 'מסמכים נוספים') }}
							</th>
							<th *ngIf="activeTab === 'company'">
								{{ t('شركات إضافية', 'Extra Companies', 'חברות נוספות') }}
							</th>
							<th *ngIf="activeTab === 'token'">
								{{ t('توكنات إضافية', 'Extra Tokens', 'טוקנים נוספים') }}
							</th>
							<th>{{ t('نشط', 'Active', 'פעיל') }}</th>
							<th>{{ t('الترتيب', 'Sort Order', 'סדר') }}</th>
							<th>{{ t('آخر تحديث', 'Updated At', 'עודכן בתאריך') }}</th>
							<th>{{ t('الإجراءات', 'Actions', 'פעולות') }}</th>
						</tr>
					</thead>

					<tbody>
						<tr *ngFor="let item of displayedPlans; let i = index">
							<td>{{ i + 1 }}</td>
							<td>{{ getPlanName(item) }}</td>
							<td>{{ getPlanDescription(item) }}</td>
							<td>{{ item.price }}</td>

							<td *ngIf="activeTab === 'main'">{{ item.documents_limit }}</td>
							<td *ngIf="activeTab === 'main'">{{ item.companies_limit }}</td>
							<td *ngIf="activeTab === 'main'">{{ item.duration_days }}</td>
							<td *ngIf="activeTab === 'main'">{{ item.analysis_tokens_limit ?? '—' }}</td>
							<td *ngIf="activeTab === 'doc'">{{ item.extra_documents }}</td>
							<td *ngIf="activeTab === 'company'">{{ item.extra_companies }}</td>
							<td *ngIf="activeTab === 'token'">{{ item.extra_tokens ?? item.documents_count ?? '—' }}</td>

							<td>
								<span class="badge" [ngClass]="item.is_active ? 'bg-success' : 'bg-danger'">
									{{ item.is_active ? t('نعم', 'Yes', 'כן') : t('لا', 'No', 'לא') }}
								</span>
							</td>
							<td>{{ item.sort_order }}</td>
							<td>{{ item.updated_at | date : "dd/MM/yyyy HH:mm" }}</td>
							<td>
								<button class="btn btn-sm btn-outline-success me-1" (click)="openEditModal(planModal, activeTab, item)">
									<i class="fa fa-edit"></i>
								</button>

								<button
									class="btn btn-sm me-1"
									[class.btn-outline-secondary]="item.is_active"
									[class.btn-outline-primary]="!item.is_active"
									(click)="togglePlanActive(activeTab, item)"
								>
									<i class="fa" [class.fa-toggle-on]="item.is_active" [class.fa-toggle-off]="!item.is_active"></i>
								</button>

								<button class="btn btn-sm btn-outline-danger" (click)="deletePlan(activeTab, item)">
									<i class="fa fa-trash"></i>
								</button>
							</td>
						</tr>

						<tr *ngIf="displayedPlans.length === 0">
							<td [attr.colspan]="emptyTableColspan" class="text-muted py-4">
								{{ t('لا توجد بيانات', 'No data found', 'לא נמצאו נתונים') }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>

<ng-template #planModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">
			{{ isEditMode ? t('تعديل الخطة', 'Edit Plan', 'עריכת תוכנית') : t('إضافة خطة جديدة', 'Create Plan', 'יצירת תוכנית') }}
			- {{ getCurrentCatalogLabel() }}
		</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>

	<div class="modal-body">
		<form [formGroup]="planForm" class="row g-3">
			<div class="col-md-4">
				<label class="form-label">{{ t('الاسم الإنجليزي', 'Name EN', 'שם באנגלית') }} *</label>
				<input type="text" class="form-control" formControlName="name_en" maxlength="120" />
				<div class="form-text">
					{{ t('هذا الحقل إلزامي', 'This field is required', 'שדה זה חובה') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('name_en')">
					{{ t('يرجى إدخال اسم صحيح وليس مسافات فقط', 'Please enter a valid name (not spaces only)', 'אנא הזן שם תקין ולא רווחים בלבד') }}
				</div>
			</div>
			<div class="col-md-4">
				<label class="form-label">{{ t('الاسم العربي', 'Name AR', 'שם בערבית') }}</label>
				<input type="text" class="form-control" formControlName="name_ar" maxlength="120" />
			</div>
			<div class="col-md-4">
				<label class="form-label">{{ t('الاسم العبري', 'Name HE', 'שם בעברית') }}</label>
				<input type="text" class="form-control" formControlName="name_he" maxlength="120" />
			</div>

			<div class="col-md-4">
				<label class="form-label">{{ t('الوصف الإنجليزي', 'Description EN', 'תיאור באנגלית') }}</label>
				<textarea class="form-control" rows="3" formControlName="description_en" maxlength="600"></textarea>
			</div>
			<div class="col-md-4">
				<label class="form-label">{{ t('الوصف العربي', 'Description AR', 'תיאור בערבית') }}</label>
				<textarea class="form-control" rows="3" formControlName="description_ar" maxlength="600"></textarea>
			</div>
			<div class="col-md-4">
				<label class="form-label">{{ t('الوصف العبري', 'Description HE', 'תיאור בעברית') }}</label>
				<textarea class="form-control" rows="3" formControlName="description_he" maxlength="600"></textarea>
			</div>

			<div class="col-md-4" *ngIf="currentCatalog === 'main'">
				<label class="form-label">{{ t('حد المستندات', 'Documents Limit', 'מגבלת מסמכים') }} *</label>
				<input type="number" class="form-control" min="1" formControlName="documents_limit" />
				<div class="form-text">
					{{ t('الحد الأقصى لعدد المستندات في الاشتراك. رقم صحيح موجب فقط.', 'Maximum documents included in the subscription. Positive integer only.', 'מספר המסמכים המקסימלי במנוי. מספר שלם חיובי בלבד.') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('documents_limit')">
					{{ t('يجب إدخال رقم صحيح أكبر من صفر', 'Must be an integer greater than zero', 'חייב להיות מספר שלם גדול מאפס') }}
				</div>
			</div>
			<div class="col-md-4" *ngIf="currentCatalog === 'main'">
				<label class="form-label">{{ t('حد الشركات', 'Companies Limit', 'מגבלת חברות') }} *</label>
				<input type="number" class="form-control" min="1" formControlName="companies_limit" />
				<div class="form-text">
					{{ t('الحد الأقصى للشركات المسموح بها في الخطة.', 'Maximum number of companies allowed in the plan.', 'מספר החברות המקסימלי המותר בתוכנית.') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('companies_limit')">
					{{ t('يجب إدخال رقم صحيح أكبر من صفر', 'Must be an integer greater than zero', 'חייב להיות מספר שלם גדול מאפס') }}
				</div>
			</div>
			<div class="col-md-4" *ngIf="currentCatalog === 'main'">
				<label class="form-label">{{ t('المدة بالأيام', 'Duration Days', 'משך בימים') }} *</label>
				<input type="number" class="form-control" min="1" formControlName="duration_days" />
				<div class="form-text">
					{{ t('مدة الاشتراك بالأيام. مثال: 30 أو 365.', 'Subscription duration in days. Example: 30 or 365.', 'משך המנוי בימים. לדוגמה: 30 או 365.') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('duration_days')">
					{{ t('يجب إدخال رقم صحيح أكبر من صفر', 'Must be an integer greater than zero', 'חייב להיות מספר שלם גדול מאפס') }}
				</div>
			</div>
			<div class="col-md-4" *ngIf="currentCatalog === 'main'">
				<label class="form-label">{{ t('حد توكنات تحليل المصاريف', 'Expense analysis tokens limit', 'מגבלת טוקני ניתוח הוצאות') }} *</label>
				<input type="number" class="form-control" min="0" formControlName="analysis_tokens_limit" />
				<div class="form-text">
					{{ t('عدد تحليلات المصاريف بالذكاء الاصطناعي المشمولة في الخطة.', 'Number of AI expense analyses included in the plan.', 'מספר ניתוחי הוצאות AI הכלולים בתוכנית.') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('analysis_tokens_limit')">
					{{ t('يجب إدخال عدد صحيح ≥ 0', 'Must be an integer ≥ 0', 'חייב להיות מספר שלם ≥ 0') }}
				</div>
			</div>

			<div class="col-md-4" *ngIf="currentCatalog === 'doc'">
				<label class="form-label">{{ t('مستندات إضافية', 'Extra Documents', 'מסמכים נוספים') }} *</label>
				<input type="number" class="form-control" min="1" formControlName="extra_documents" />
				<div class="form-text">
					{{ t('عدد المستندات الإضافية التي ستضاف للاشتراك.', 'How many additional documents will be added.', 'מספר המסמכים הנוספים שיתווספו למנוי.') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('extra_documents')">
					{{ t('يجب إدخال رقم صحيح أكبر من صفر', 'Must be an integer greater than zero', 'חייב להיות מספר שלם גדול מאפס') }}
				</div>
			</div>

			<div class="col-md-4" *ngIf="currentCatalog === 'company'">
				<label class="form-label">{{ t('شركات إضافية', 'Extra Companies', 'חברות נוספות') }} *</label>
				<input type="number" class="form-control" min="1" formControlName="extra_companies" />
				<div class="form-text">
					{{ t('عدد الشركات الإضافية التي ستضاف للاشتراك.', 'How many additional companies will be added.', 'מספר החברות הנוספות שיתווספו למנוי.') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('extra_companies')">
					{{ t('يجب إدخال رقم صحيح أكبر من صفر', 'Must be an integer greater than zero', 'חייב להיות מספר שלם גדול מאפס') }}
				</div>
			</div>

			<div class="col-md-4" *ngIf="currentCatalog === 'token'">
				<label class="form-label">{{ t('توكنات إضافية', 'Extra Tokens', 'טוקנים נוספים') }} *</label>
				<input type="number" class="form-control" min="1" formControlName="extra_tokens" />
				<div class="form-text">
					{{ t('عدد توكنات تحليل المصاريف التي تُضاف للاشتراك عند الشراء.', 'How many expense analysis tokens are added to the subscription when purchased.', 'מספר טוקני ניתוח ההוצאות שיתווספו למנוי בעת הרכישה.') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('extra_tokens')">
					{{ t('يجب إدخال رقم صحيح أكبر من صفر', 'Must be an integer greater than zero', 'חייב להיות מספר שלם גדול מאפס') }}
				</div>
			</div>

			<div class="col-md-4">
				<label class="form-label">{{ t('السعر', 'Price', 'מחיר') }} *</label>
				<input type="number" class="form-control" min="0.01" step="0.01" formControlName="price" />
				<div class="form-text">
					{{ t('سعر الخطة. يسمح بفواصل عشرية مثل 120.50', 'Plan price. Decimals are allowed, e.g. 120.50', 'מחיר התוכנית. מותר ערך עשרוני כמו 120.50') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('price')">
					{{ t('يجب إدخال سعر أكبر من صفر', 'Price must be greater than zero', 'המחיר חייב להיות גדול מאפס') }}
				</div>
			</div>

			<div class="col-md-4">
				<label class="form-label">{{ t('الترتيب', 'Sort Order', 'סדר') }}</label>
				<input type="number" class="form-control" min="0" formControlName="sort_order" />
				<div class="form-text">
					{{ t('كلما كان الرقم أصغر، ظهرت الخطة أولًا. يبدأ من 0.', 'Smaller numbers appear first. Starts from 0.', 'מספר קטן יותר יוצג קודם. מתחיל מ-0.') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('sort_order')">
					{{ t('يجب أن يكون رقمًا صحيحًا أكبر أو يساوي 0', 'Must be an integer greater than or equal to 0', 'חייב להיות מספר שלם גדול או שווה ל-0') }}
				</div>
			</div>

			<div class="col-md-4 d-flex align-items-center">
				<div class="form-check mt-4">
					<input class="form-check-input" type="checkbox" formControlName="is_active" id="isActiveCheckbox" />
					<label class="form-check-label" for="isActiveCheckbox">
						{{ t('الخطة نشطة', 'Plan is active', 'התוכנית פעילה') }}
					</label>
				</div>
			</div>
		</form>
	</div>

	<div class="modal-footer">
		<button class="btn btn-dark" [disabled]="isSubmitting" (click)="submitPlan()">
			{{ isEditMode ? t('حفظ التعديل', 'Save Changes', 'שמירת שינויים') : t('إنشاء', 'Create', 'יצירה') }}
		</button>
		<button class="btn btn-outline-danger" (click)="modal.dismiss()">
			{{ t('إلغاء', 'Cancel', 'ביטול') }}
		</button>
	</div>
</ng-template>
